<div class="nexleader-chart-skill-comparison-wrapper">
  <canvas id="horizontal-bar"></canvas>
</div>
